import { Box } from '@mui/material';
import { ResponsiveBar } from '@nivo/bar';
import ChartSection from '../shared/ChartSection';
import ChartTooltip from '../shared/ChartTooltip';
import useNivoTheme from '../shared/useNivoTheme';

export default function MostTradedStocks({ data }) {
    const { theme, colors } = useNivoTheme();
    if (!data || data.length === 0) return null;

    const chartData = data.slice(0, 15).map(t => ({
        ticker: t.ticker,
        Buys: t.buys,
        Sells: t.sells,
    }));

    return (
        <ChartSection
            id="most-traded"
            title="What stocks does Congress trade most?"
            subtitle="Top 15 tickers by total congressional trade count — buys vs sells"
        >
            <Box sx={{ height: 420 }}>
                <ResponsiveBar
                    data={chartData}
                    keys={['Buys', 'Sells']}
                    indexBy="ticker"
                    margin={{ top: 20, right: 130, bottom: 50, left: 50 }}
                    padding={0.3}
                    colors={[colors.buyFg, colors.sellFg]}
                    borderRadius={3}
                    enableLabel={false}
                    axisBottom={{ tickRotation: -30 }}
                    axisLeft={{ legend: 'Trades', legendPosition: 'middle', legendOffset: -40 }}
                    legends={[
                        {
                            dataFrom: 'keys',
                            anchor: 'top-right',
                            direction: 'column',
                            translateX: 120,
                            itemWidth: 110,
                            itemHeight: 20,
                            symbolSize: 10,
                            itemTextColor: '#9ca3af',
                        },
                    ]}
                    tooltip={({ id, value, data: d, color }) => (
                        <ChartTooltip
                            title={d.ticker}
                            rows={[{ label: id, value: value.toLocaleString(), color }]}
                        />
                    )}
                    theme={theme}
                />
            </Box>
        </ChartSection>
    );
}
